import { Device } from "openvidu-browser";

export interface broadcastSettings {
    microphoneDevice?: Device;
    cameraDevice?: Device;
    microphoneThreshold: number;
};
export interface broadcastBasePortatritsDimensions {
    width: number,
    height: number,
    orizzontalMargin: number,
    verticalMargin: number,
};

//interno sta per interno alla company / esterno per esterno alla company (es: un guest temporaneo che partecipa alla videocall)
export enum UserTypes {  //NB: per adesso tutti gli utenti che usano il teletabber per mandare lo streaming video vengono considerati externalOpenvidu anche se interni all'azienda. 
    undefined = 0,
    internal = 1,
    internalOpenvidu = 2,
    external = 3,
    externalOpenvidu = 4,
    grabber = 5,
    regia = 6,
};

export enum BroadcastLauncherTypes {
    userCanChoose = 0,
    onlyExternalSystem = 1,
    onlyOpenVidu = 2,
};

export interface BroadcastDto {
    sessionId: string;
    lastUpdate: Date;
    token?: string;
    userList: BroadcastUserDataDto[];
    isCloseSessionMassiveLogoutEnabled: boolean;
};
export class BroadcastUserDataDto {
    sessionId: string | null = null; 
    userId: number | null = null; 
    grabberId: number | null = null; 
    username: string = "";
    email: string = "";
    isChairman : boolean = false;
    handRaisedPriority: number = 0;
    broadcastUserTypeId: UserTypes = UserTypes.undefined;
    canHandleGrabbers : boolean = false;
    canEditBroadcast : boolean = false;
    connectionId? : string = undefined;
    isSpeaking : boolean = false;
    error? : string = undefined;

    constructor(init?: BroadcastUserDataDto) {
        Object.assign(this, init);
      }
};

export interface SynchronizedBroadcastStatus {
    isSynchronized : boolean,
    broadcastStatus : BroadcastDto
}

